import type { App } from '../ducks/apps/App'

export const isSupportedOnWeb = (platform: App['primaryPlatform']): boolean =>
  platform === 'web' || platform === 'responsive'
